import { Component, ViewChild } from '@angular/core';
import { HoverPanelService } from './hover-panel.service';

@Component({ standalone: false,
    selector: 'hover-panel-container',
    template: `
      <div class="hover-panel-container">
        @if (hoverPanel) {
          <hover-panel
            #hp
            [template]="hoverPanel.template"
            [position]="hoverPanel.position"
            [ref]="hoverPanel.ref"
            [width]="hoverPanel.width"
            [height]="hoverPanel.height"
            [event]="hoverPanel.event"
            [zIndex]="hoverPanel.zIndex"
            [onClose]="hoverPanel.onClose">
          </hover-panel>
        }
      </div>
      `
  })
  export class HoverPanelContainerComponent {  
    @ViewChild("hp") hp: any;
    hoverPanel: any = null;

    constructor(private hps: HoverPanelService) {
      this.hps.getComponents().subscribe((hp) => {
        this.hoverPanel = hp;
      });

      this.hps.getChanges().subscribe((d: any) => {
        if(d === "redraw" && this.hp) {
          this.hp.redraw();
        } else if(d === "resize" && this.hp) {
          this.hp.resize();
        }
      });
    }  
  }
